module.exports = __webpack_public_path__ + "assets/img/home_p_1.853f752e.png";